<template>
  <div class="banner-group">
    <div
      class="banner-group__title"
      :style="{
        color: itemStyle.titleColor,
      }"
    >
      {{ title }}
    </div>
    <VantTabs
      v-model="currentIndex"
      class="banner-group__banner-list"
      line-height="0"
      @click="handleBannerChange"
    >
      <VantTab
        v-for="(banItem, index) in bannerList"
        :key="index"
        title-style="width:25%;padding:0;"
        :title-class="index === bannerList.length - 1 ? 'last' : ''"
      >
        <template #title>
          <div
            class="banner-group__banner-item"
            :class="
              index === currentIndex && 'banner-group__banner-item--active'
            "
          >
            <div
              class="banner-group__banner-item-imgbox"
              :style="{
                borderColor:
                  index === currentIndex
                    ? itemStyle.itemTitleBorderColorActive
                    : 'transparent',
                borderRadius: itemStyle.itemTitleBorderRadius,
              }"
            >
              <img :src="banItem.src" class="banner-group__banner-item-img" />
            </div>
            <div
              class="banner-group__banner-item-title"
              :style="{
                color:
                  index === currentIndex
                    ? itemStyle.itemTitleColorActive
                    : itemStyle.itemTitleColor,
              }"
            >
              {{ banItem.title }}
            </div>
          </div></template
        ></VantTab
      >
    </VantTabs>
    <div class="banner-group__content" v-if="bannerList.length > 0">
      <VantSwiper
        autoplay="3000"
        :show-indicators="false"
        :initial-swipe="initialSwipe"
        ref="swiperRef"
        @change="handlePageChange"
        class="banner-group__swiper-container"
      >
        <VantSwipeItem
          class="banner-group__swiper-slide"
          v-for="(banItem, index) in bannerList[currentIndex].img_list"
          :key="index"
        >
          <img :src="banItem" class="banner-group__swiper-img" />
        </VantSwipeItem>
      </VantSwiper>
      <div class="pagination-box">
        <ul class="swiper-pagination">
          <li
            v-for="(item, index) in bannerList[currentIndex].img_list"
            :key="index"
            class="swiper-pagination-bullet"
            :class="
              index === currentSwiperIndex && 'swiper-pagination-bullet-active'
            "
            :style="{
              backgroundColor:
                index === currentSwiperIndex
                  ? itemStyle.itemDotColorActive
                  : itemStyle.itemDotColor,
            }"
          ></li>
        </ul>
      </div>
    </div>
    <div
      class="banner-group__content-bk"
      :style="{
        backgroundColor: itemStyle.itemBkColor,
      }"
    ></div>
  </div>
</template>
<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// eslint-disable-next-line object-curly-newline
import { Swipe, SwipeItem, Tab, Tabs } from "vant";

export default {
  props: {
    bannerList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "特殊主题店型",
    },
    itemStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
      currentSwiperIndex: 0,
      initialSwipe: 0,
      swiperRef: "",
    };
  },
  created() {},
  mounted() {
    this.$nextTick((e) => {
      if (this.$refs.swiperRef) {
        this.swiperRef = this.$refs.swiperRef;
      }
    });
  },
  methods: {
    handleBannerChange() {
      const banItem = this.bannerList[this.currentIndex];
      setTimeout(() => {
        this.swiperRef.swipeTo(0, { immediate: true });
      }, 50);
      window.sensors.track("JoinPageClick", {
        join_module_name: "特殊主题店型",
        join_name: banItem.title,
        join_destination_url: "",
      });
    },
    handlePageChange(index) {
      this.currentSwiperIndex = index;
    },
  },
  components: {
    VantSwiper: Swipe,
    VantSwipeItem: SwipeItem,
    VantTab: Tab,
    VantTabs: Tabs,
  },
};
</script>
<style lang="scss" >
  .banner-group {
    width: 100%;
    height: 100%;
    padding-bottom: 12px;
    &__title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      margin-bottom: 30px;
    }
    &__banner-list {
      width: 100%;
      margin-bottom: 20px;
      padding: 0 16px;
      justify-content: flex-start;
    }
    &__banner-item-imgbox {
      //   border: 1px solid #000;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      margin: 0 auto 4px;
    }
    &__banner-item-img {
      width: 100px;
      height: 100px;
    }
    &__banner-item-title {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    &__banner-item--active {
      .banner-group__banner-item-imgbox {
        border: 4px solid #3eae2c;
      }
      .banner-group__banner-item-title {
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1a9605;
      }
    }
    &__swiper-img {
      border-radius: 32px;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    &__content {
      border-radius: 32px;
      overflow: hidden;
      height: 440px;
      position: relative;
      z-index: 9;
    }
    &__content-bk {
      //   width: 98%;
      width: 668px;
      height: 400px;
      background-color: #5ec648;
      border-radius: 32px;
      overflow: hidden;
      position: absolute;
      //   left: 1%;
      left: 0;
      right: 0;
      margin: auto;
      bottom: 0;
    }

    .pagination-box {
      width: 100%;
      height: 34px;
      bottom: 18px;
      position: absolute;
      text-align: center;
      display: flex;
      justify-content: center;
    }

    .swiper-pagination {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 22px;
      margin: auto;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 16px;
    }
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      margin: 0 5px;
      align-self: center;
      display: flex;
      background-color: #999999;
      opacity: 1;
      transition: all 0.2s ease;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      width: 14px;
      height: 14px;
      //   margin: 0 7px;
      //   background-color: #b9ff41;
    }
  }
</style>

<style lang="scss">
  .banner-group {
    .van-tabs__wrap {
      height: 100% !important;
    }
    .van-tab__text {
      width: 100%;
    }
    .van-tabs__nav {
      padding: 0 !important;
    }
    .van-tab {
      //   width: 25% !important;
      width: auto !important;
      flex: none;
      margin-right: calc((100% - 480px - 16px) / 3);
    }

    .van-tab.last {
      margin-right: 0;
    }
  }
</style>
